<form [formGroup]="list" [id]="id">
    <div class="sh-form-row-with-action" style="margin-bottom: 0" *ngFor="let item of list.controls; let i = index">
        <div class="sh-form-row-with-action__inputs">
            <div class="sh-form-row-with-action__inputs__item">
                <sh-form-select-base
                    [formControl]="getTypeControl(i)"
                    [id]="getTypeId(i)"
                    [options]="types"
                    [placeholderMsg]="typePlaceholderMsg"
                    [isDisabled]="disabled"
                    class="sh-form-group__input"
                ></sh-form-select-base>
            </div>
            <div class="sh-form-row-with-action__inputs__item">
                <sh-form-label
                    *ngIf="valueLabel"
                    [label]="valueLabel"
                    [for]="getValueId(i)"
                    [required]="required"
                    [class.sh-visually-hidden]="showLabel(i)"
                ></sh-form-label>
                <sh-autocomplete [autocompleteFct]="autocompleteStreams[i] | async">
                    <input
                        type="text"
                        autocomplete="off"
                        [formControl]="getValueControl(i)"
                        [id]="getValueId(i)"
                        [attr.placeholder]="valuePlaceholderMsg || null"
                        [attr.disabled]="disabled ? true : null"
                        class="sh-form-group__input sh-input-field"
                    />
                </sh-autocomplete>
            </div>
            <div *ngIf="actionItems" class="sh-form-row-with-action__actions">
                <sh-action-item class="sh-form-row-with-action__actions__item" *ngFor="let actionItem of actionItems[i]" [item]="actionItem"></sh-action-item>
            </div>
        </div>
    </div>
</form>
<p *ngIf="isIndeterminate && indeterminateMsg" class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
